<template>
  <div>
    <div
      id="filter-1"
      class="row pt-4"
      style="border-top: 1px solid #e0e0e0;"
      v-if="tem_permissao"
    >
      <div class="Search">
        <div class="col s12">
          <span class="Search__title grey-text">Por responsável:</span>
        </div>

        <div
          class="chip mt-3"
          v-for="responsavel in respSelecionados"
          v-bind:key="responsavel.funcionario_id"
        >
          {{responsavel.pessoa_nome}}
          <i
            class="close material-icons"
            @click="removerResponsavelSelecionado(responsavel)"
          >close</i>
        </div>

        <div class="Search input-field col s12 input-search">
          <i class="material-icons">person_outline</i>
          <input
            type="text"
            @input="debounceResponsaveis"
            class="autocomplete"
            id="responsavel-input"
          />
          <i
            @click="limparCampoResponsavel()"
            class="material-icons md-18 grey-text clear">
            clear
          </i>
          <label for="nome" />
        </div>
      </div>
    </div>

    <ul
      class="collection"
      v-if="checarCargoFuncionario(
        [cargoDono, cargoGerente, cargoEspecialista],
        [cargoDono, cargoGerente, cargoEspecialista])"
    >
      <li
        class="collection-item pl-0 pr-0"
        style="display: flex;justify-content: space-between;"
        v-for="responsavel in responsaveisPadrao.itens"
        v-bind:key="responsavel.funcionario_id"
      >
        <span
          class="title"
          style="text-transform: capitalize; font-size: .9rem"
        >{{ responsavel.pessoa_nome.toLowerCase() }}</span>
        <input
          :id="'responsavel'+responsavel.funcionario_id"
          :value="responsavel.funcionario_id"
          type="checkbox"
          v-model="responsaveis"
          @change="$emit('change', {responsaveis, respSelecionados} )"
        />
        <label :for="'responsavel'+responsavel.funcionario_id" />
      </li>
    </ul>
  </div>
</template>

<script>
import { debounce } from "lodash";
import * as constant from "@/constants/funcionarioCargo.js";
import { get } from "@/helpers/api";
import { checaCargo } from "@/helpers/perfil";
import { listarPessoas, recuperarSelecionados } from "./funcoesFiltro";

export default {
  name: "FiltroPorResponsaveis",

  props: {
    responsaveis: {
      type: Array,
      default: () => []
    }
  },

  computed: {
    tem_permissao() {
      return this.checarCargoFuncionario(
        [this.cargoDono, this.cargoGerente, cargoEspecialista],
        [this.cargoDono, this.cargoGerente, cargoEspecialista]
      )
    }
  },

  data: () => ({
    respSelecionados: [],
    responsaveisPadrao: {
      itens: [],
      typed: null
    },

    cargoDono: constant.DONO,
    cargoGerente: constant.GERENTE,
    cargoCorretor: constant.CORRETOR,
    cargoEspecialista: constant.ESPECIALISTA,
    cargoParceiro: constant.PARCEIRO,
    cargoMaster: constant.MASTER
  }),

  watch: {
    "responsaveisPadrao.typed"() {
      this.responsaveisPadrao.itens = [];

      if (this.responsaveisPadrao.typed) {
        listarPessoas(this.responsaveis, this.responsaveisPadrao.typed)
          .then(response => {
            this.responsaveisPadrao.itens = response;
        });
      }
    },

    responsaveis: {
      immediate: true,
      deep: true,
      handler(newValue, oldValue) {
        this.gerarSelecionados(newValue, oldValue);
      }
    }
  },

  async created() {
    if (this.tem_permissao)
    {
      this.respSelecionados = await recuperarSelecionados(this.responsaveis);
    }
  },

  methods: {
    gerarSelecionados(newValue, oldValue) {

      if (oldValue === undefined) return;

      let newData = [...newValue];

      newData = newData.pop();
      if (!oldValue.includes(newData)) {
        const dataToPush = this.responsaveisPadrao.itens.filter(
          item => item.funcionario_id == newData
        );

        if (dataToPush.length) {
          const newItem = dataToPush.pop();

          if (!this.respSelecionados.find(i => i == newItem)) {
            this.respSelecionados.push(newItem);
          }
        }
      }
    },

    checarCargoFuncionario(cargoMono, cargoMulti) {
      return checaCargo(cargoMono, cargoMulti);
    },

    removerResponsavelSelecionado(resposnavel) {

      this.respSelecionados = this.respSelecionados.filter(i => i != resposnavel);

      const nvoaListaResponsaveis = this.responsaveis.filter(
        i => i.toString() != resposnavel.funcionario_id.toString());

      this.responsaveis = nvoaListaResponsaveis;

      this.$emit("removeSelecionado", {
        responsaveis: this.responsaveis,
        respSelecionados: this.respSelecionados
      });
    },

    limparCampoResponsavel() {
      this.responsaveisPadrao.typed = "";
      $("#responsavel-input").val("");
    },

    debounceResponsaveis: debounce(function(e) {
      let time;
      clearTimeout(time);
      const self = this;
      time = setTimeout(
        () => (self.responsaveisPadrao.typed = e.target.value),
        500
      );
    }, 200)
  }
};
</script>
<style scoped />



// WEBPACK FOOTER //
// src/components/lead/listagem/FiltroPorResponsaveis.vue